export default __webpack_public_path__ + "static/media/img_noData_facebook.d1114791.svg";